import { UPDATE_DESIGN, UPDATE_LAYOUT, UPDATE_TEXTS } from '../actions';

export function editorSettingsDesign(state = {}, action) {
  switch (action.type) {
    case UPDATE_DESIGN: {
      return { ...state, ...action.design };
    }
    default:
      return state;
  }
}

export function editorSettingsLayout(state = {}, action) {
  switch (action.type) {
    case UPDATE_LAYOUT: {
      return { ...state, ...action.layout };
    }
    default:
      return state;
  }
}

export function editorSettingsTexts(state = {}, action) {
  switch (action.type) {
    case UPDATE_TEXTS: {
      return { ...state, ...action.texts };
    }
    default:
      return state;
  }
}
